module.exports = __webpack_public_path__ + "static/media/Cocktail_Coterie.1e4911de.PNG";